import { useQuery } from "react-query";
import { CheckInAPI } from "api/judge/checkIn";
import { CHECK_IN } from "helpers/constants";

export default function useCheckIns(ringId) {
  return useQuery([CHECK_IN, ringId], () => CheckInAPI.getCheckIns(ringId), {
    enabled: !!ringId,
  });
}
